import { render } from "./ChatTable.vue?vue&type=template&id=2c583aaa&ts=true"
import script from "./ChatTable.vue?vue&type=script&lang=ts"
export * from "./ChatTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__